<template>
<div>

  <v-banner class="mb-2">
    <v-btn class="pt-0" rounded outlined color="secondary" @click="openCreateDialog">
      <v-icon left>mdi-plus</v-icon> Ajouter un média
    </v-btn>
  </v-banner>

  <v-row dense>

    <!-- <pre>{{this.$store.state.arrFilters}}</pre> -->

    <v-col cols="3" v-for="media in this.$store.state.arrMedias" :key="media.id">

      <v-hover >
        <template v-slot:default="{ hover }">
          <v-card>
            <v-img
                    class="white--text align-end"
                    height="180px"
                    gradient="to bottom, rgba(0,0,0,.1), rgba(0,0,0,.5)"
                    :src="media.thumb"
            >
            </v-img>

            <v-card-subtitle v-if='media.title == ""'>{{media.filename}}</v-card-subtitle>
            <v-card-subtitle v-if='media.title != ""'>{{media.title}}</v-card-subtitle>
            <v-fade-transition>
              <v-overlay
                      v-if="hover"
                      absolute
                      color="primary"
              >
              <a :href="media.url+'?force_download'" style="text-decoration:none;">
                <v-icon class="mdi mdi-download icons download"  rounded outlined color="#fff" @mouseover="setLibelle('Télécharger le média')" @mouseleave="removeLibelle()"></v-icon>
              </a>
                <v-icon v-if="media.mime.indexOf('image') != -1" class="mdi mdi-image-edit-outline icons generate" @click='openGenerateDialog(media.id)' rounded outlined color="#fff" @mouseover="setLibelle('Générez')" @mouseleave="removeLibelle()"></v-icon>
                <v-icon class="mdi mdi-magnify icons" @click='openDetails(media.id)' rounded outlined color="#fff" @mouseover="setLibelle('Détail du média')"  @mouseleave="removeLibelle()"></v-icon>
                <v-icon class="mdi mdi-delete-forever icons delete" @click='deleteMedia(media.id)' rounded outlined color="#fff" @mouseover="setLibelle('Effacer le média')" @mouseleave="removeLibelle()"></v-icon>
                <p class="libelle">{{libelle}}</p>
              </v-overlay>
            </v-fade-transition>

          </v-card>
        </template>
      </v-hover>
    </v-col>
  </v-row>
  <Modal/>
  <CreateModal/>
  <GenerateModal/>
</div>


</template>

<script>
import Modal from '../components/Modal'
import CreateModal from '../components/CreateModal'
import GenerateModal from '../components/GenerateModal'

  export default {
    name: 'Options',
    components: {
        Modal,
        CreateModal,
        GenerateModal
    },
    data() {  
      return{
        //arrMedias: null
        libelle: ""
      }
    },
    created () {
      // this.$store.dispatch('initInfosMetas');
      // this.$store.dispatch('initArrayMedias');
    },
    beforeMount() {
      
    },
    methods: {
        openDetails(mediaId){
            this.$store.dispatch('setMediaDetail', mediaId);
            this.$store.dispatch('setDialog', true);
        },
        openCreateDialog(){
          this.$store.dispatch('setDialogCreate', true)
        },
        openGenerateDialog(mediaId){
          this.$store.dispatch('setMediaDetail', mediaId);
          this.$store.dispatch('setDialogGenerate', true)
        },
        deleteMedia(mediaId){
          this.$store.dispatch('deleteMedia', mediaId);
        },
        setLibelle(libelle) {
          this.libelle = libelle
        },
        removeLibelle(){
          this.libelle = "";
        }
    }
  }
</script>

<style lang="scss">
  @import '~vuetify/src/styles/styles.sass';
  .v-banner__wrapper{
    padding:6px 0 12px 0 !important;
  }
  .icons {
    border:1px solid #FFF;
    border-radius:50%;
    margin:0 5px;
    padding:5px;
    &:hover {
      background-color:#FFF;
      color: #028cba !important;
    }
    &.delete {
      &:hover {
        background-color:#FFF;
        color: red !important;
      }
    }
    &.generate {
      &:hover {
        background-color:#FFF;
        color: green !important;
      }
    }
    
  }
  .v-overlay {
    width:100%;
  }
  .libelle {
      margin-top:10px;
      position:absolute;
      width:100%;
      text-align:center;
    }
</style>